import styled from "styled-components";

export const FormGroup = styled.div`
  margin: 0.5rem 0;
  display: flex;
  flex-direction: column;

  input {
    width: 100%;
    border: none;
    outline: none;
    padding: 0.5rem;
    border-radius: 5px;
    border: 1px solid #c8cccf;
    -webkit-appearance: none;
  }

  /* input::placeholder {
    font-size: 8px;
    letter-spacing: 0.5px;
    color: #b29d9d; */
  /* } */

  ::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    font-size: 8px;
  }
  ::-moz-placeholder {
    /* Firefox 19+ */
    font-size: 8px;
  }
  :-ms-input-placeholder {
    /* IE 10+ */
    font-size: 8px;
  }
  :-moz-placeholder {
    /* Firefox 18- */
    font-size: 8px;
  }
`;

export const Label = styled.label`
  font-size: 14px;
  display: block;
  margin: 6px 0;
  color: ${({ theme }) => theme.text};
`;

export const Field = styled.input``;
